import type { EntityOptions } from 'models';
import type { ReactNode } from 'react';
import { Col, InfinityLoading, Row, Skeleton } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import type { EntityListItem } from 'features/channels/types';
import { EntityCard } from '../entity-card';

type P = {
  empty: ReactNode;
  entities?: EntityListItem[];
  fetchNextPage: () => void;
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  hasNextPage?: boolean;
  // TODO replace these query props with one query prop
  isFetching: boolean;
  isLoading: boolean;
  showPrice?: boolean;
  showTag?: boolean;
};

// TODO: move this out of channels, as `EntityCard` uses also entities that do not belong to the channels
const EntityList = ({
  empty,
  entities,
  fetchNextPage,
  getPathToEntityDetail,
  hasNextPage,
  isFetching,
  isLoading,
  showPrice,
  showTag,
}: P) => (
  <>
    {isLoading || !entities ? (
      <Skeleton active paragraph={{ rows: 12 }} />
    ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
    entities.length === 0 ? (
      empty
    ) : (
      <>
        <Row gutter={['ms', 'lg']}>
          {entities.map((entity) => (
            <Col key={entity.data.id} span={6}>
              <EntityCard
                entity={entity}
                getPathToEntityDetail={getPathToEntityDetail}
                showPrice={showPrice}
                showTag={showTag}
              />
            </Col>
          ))}
        </Row>
        <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
      </>
    )}
  </>
);

export default EntityList;
